import { createContext } from 'react';

export enum PageType {
  PAGE = 'page',
  PRODUCT = 'product',
}
export interface TrackingContextData {
  applicationName?: string;
  pageGroup?: string;
  page?: string;
  type?: PageType;
  section?: string;
}

export const defaultContextValue = {};

export default createContext<TrackingContextData>({ ...defaultContextValue });
